// Add your custom JS here.

jQuery(document).ready(function($){

// Basic (Home Page) Slider.
  $('.hp-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    autoplaySpeed: 5000
  });

// Featured News Slider.
  $('.featured-news').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    dots: true,
    fade: true
  });

// Logo Strip.
  $('.logo-strip').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    dots: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

// Search Tab event to open Search Drawer.
    $('.searchToggle').click (function() {
      $(this).toggleClass('open');
      $('.nav-search').toggleClass('open');
    });

// Get current year for colophon.
    const d = new Date();
    let year = d.getFullYear();
    document.getElementById('copyrightYear').innerHTML = year;

// Conditional page wrapper classes to change padding if the Top Bar exists.
    if ( $( '.top-bar' ).length ){
      $( '#single-wrapper,#archive-wrapper,#user-wrapper,#search-wrapper,.hp-slide,.hp-slider' ).addClass( 'topBarEnabled' );
    } else {
      $( '#single-wrapper,#archive-wrapper,#user-wrapper,#search-wrapper,.hp-slide,.hp-slider' ).addClass( 'topBarDisabled' );
    }

// Conditional classes to change Home page header elements on scroll.
    function alterClass() {
      var yScroll = $(window).scrollTop();
      if (yScroll >= 100) {
        $('.home .top-bar,.home #main-nav.bg-primary,.home .nav-search').addClass('xparent');
      }
      else if (yScroll <= 99) {
        $('.home .top-bar,.home #main-nav.bg-primary,.home .nav-search').removeClass('xparent');
      };
    }

    //Fire when the page first loads...
    alterClass();

    //...when the user scrolls...
    $(window).scroll(function() {
      alterClass();
    });

    //...and when the window is resized.
    $(window).resize(function() {
      alterClass();
    });

// Add classes for the scroll fx. All 34 of them...
    jQuery('.pulseMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__pulse',
        offset: 100
      });

    jQuery('.rubberbandMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__rubberBand',
        offset: 100
      });

    jQuery('.backMeInLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__backInLeft',
        offset: 100
      });

    jQuery('.backMeInRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__backInRight',
        offset: 100
      });

    jQuery('.backMeInUp').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__backInUp',
        offset: 100
      });

    jQuery('.backMeInDown').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__backInDown',
        offset: 100
      });

    jQuery('.bounceMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__bounceIn',
        offset: 100
      });

    jQuery('.bounceMeInDown').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__bounceInDown',
        offset: 100
      });

    jQuery('.bounceMeInLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__bounceInLeft',
        offset: 100
      });

    jQuery('.bounceMeInRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__bounceInRight',
        offset: 100
      });

    jQuery('.bounceMeInUp').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__bounceInUp',
        offset: 100
      });

    jQuery('.fadeMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeIn',
        offset: 100
      });

    jQuery('.fadeMeInDown').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInDown',
        offset: 100
      });

    jQuery('.fadeMeInDownBig').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInDownBig',
        offset: 100
      });

    jQuery('.fadeMeLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInLeft',
        offset: 100
      });

    jQuery('.fadeMeLeftBig').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInLeftBig',
        offset: 100
      });

    jQuery('.fadeMeRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInRight',
        offset: 100
      });

    jQuery('.fadeMeRightBig').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInRightBig',
        offset: 100
      });

    jQuery('.fadeMeUp').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInUp',
        offset: 100
      });

    jQuery('.fadeMeUpBig').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__fadeInUpBig',
        offset: 100
      });

    jQuery('.flipMeInX').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__flipInX',
        offset: 100
      });

    jQuery('.flipMeInY').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__flipInY',
        offset: 100
      });

    jQuery('.lightSpeedMeInRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__lightSpeedInRight',
        offset: 100
      });

    jQuery('.lightSpeedMeInLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__lightSpeedInLeft',
        offset: 100
      });

    jQuery('.jackInTheBoxMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__jackInTheBox',
        offset: 100
      });

    jQuery('.zoomMeIn').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__zoomIn',
        offset: 100
      });

    jQuery('.zoomMeInDown').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__zoomInDown',
        offset: 100
      });

    jQuery('.zoomMeInLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__zoomInLeft',
        offset: 100
      });

    jQuery('.zoomMeInRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__zoomInRight',
        offset: 100
      });

    jQuery('.zoomMeInUp').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__zoomInUp',
        offset: 100
      });

    jQuery('.slideMeInDown').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__slideInDown',
        offset: 100
      });

    jQuery('.slideMeInLeft').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__slideInLeft',
        offset: 100
      });

    jQuery('.slideMeInRight').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__slideInRight',
        offset: 100
      });

    jQuery('.slideMeInUp').addClass('hidden').viewportChecker({
        classToAdd: 'visible animate__animated animate__slideInUp',
        offset: 100
      });

// jQuery UI.
      $( "#accordion,.accordion" ).accordion({
        heightStyle: "content",
        autoHeight: false,
        clearStyle: true,
        collapsible: true
      });

      $( "#tabs" ).tabs();

});